module.exports = __webpack_public_path__ + "media/images/faces/male/42-6d1be94e68dfb4380b80e1c79753ab71.jpg";